module.exports = __webpack_public_path__ + "media/mypage/images/jisseki/jisseki13_pc-05e76963db1125519a1c69794d0cfe52.jpg";